import FieldsGeneratorRaw from './../../FieldsGenerator'
export default {
  name: 'Collapse',
  mixins: [FieldsGeneratorRaw],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: Object
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: Object
    }
  },
  model: {
    prop: 'modelProps',
    event: 'not-mutable'
  },
  data () {
    return {
      items: this.config.items
    }
  },
  created () {
    this.addVVScope()
  },
  methods: {
    formatString (string) {
      // eslint-disable-next-line no-eval
      return eval(string)
    },
    async validate () {
      let vm = this
      Object.keys(this.items).forEach(element => {
        try {
          let obj = this.items[element]
          vm.$refs[`${vm._uid}${obj['fieldName'] ? obj['fieldName'] : ''}${element}`][0].validate()
        } catch (error) {
          console.log(error)
        }
      })
    },
    addVVScope() {
      for(let key in this.items) {
        this.items[key].vvScope = this.config.vvScope
        if(this.config.readonly) {
          this.items[key].readonly = true
        }
        this.initDataForContainer(this.items[key])
      }
    }
  },
  watch: {
    config(newValue) {
      this.items = newValue.items
      this.addVVScope()
    }
  }
}
